export const meetingCountdownNow = "WOJJFc";
export const meetingCountdownInXTime = "oA3byb";
export const meetingCountdownUpNext = "_i805b";
export default {meetingCountdownNow,meetingCountdownInXTime,meetingCountdownUpNext};